import { render, staticRenderFns } from "./ResyncPatientExternallyModal.vue?vue&type=template&id=4ed41f8e&scoped=true"
import script from "./ResyncPatientExternallyModal.vue?vue&type=script&lang=js"
export * from "./ResyncPatientExternallyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed41f8e",
  null
  
)

export default component.exports